<script setup lang="ts"></script>

<template>
  <FormKit
    type="togglebuttons"
    name="state"
    label="Ticket status"
    :options="['Unassigned', 'In Progress', 'Closed']"
    multiple
    enforced
    :value="['Unassigned', 'In Progress']"
  />
</template>
